import React from 'react';
import Component from '../../components/Component';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as actions from '../../redux/modules/calendar';
import Moment from 'moment';
import immutable from 'immutable';
import Calendar from './Calendar';

@connect((state, props) => {
	return {
		filterDate: state.forms.getIn(['calendar.month.view', 'values', 'date'])
	};
}, (dispatch) => {
	return {actions: bindActionCreators(actions, dispatch)};
}, null, {withRef: true })
export default class Detail extends Component {

	constructor(props, context) {
		super(props);
		const defaultDate = new Moment().format('YYYY-MM-DD');
		this.state = {
			date: this.props.routeParams.date ? this.props.routeParams.date : (this.props.filterDate ? this.props.filterDate : defaultDate)
		}
	}

	componentWillReceiveProps(nextProps) {
		if (nextProps.routeParams.date != this.props.routeParams.date) {
			this.setState({date: nextProps.routeParams.date})
		}
		else if (nextProps.filterDate != this.props.filterDate) {
			this.props.actions.setDate(nextProps.filterDate);
			this.setState({date: nextProps.filterDate});
		}
	}

	render() {
		return (
			<Calendar date={this.state.date} />
		)
	}
}


// WEBPACK FOOTER //
// ./src/containers/Calendar/Page.js